import React from 'react';
import { Heading, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';

import { head } from 'lodash';
import { useTranslate } from '../../hooks/useTranslate';

const SectionMultiEnumMaybe = props => {
  const { heading, options, selectedOptions, showUnselectedOptions = true, fieldName, listingId, lastFetch } = props;
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }

  const { translation } = useTranslate(
    {
      [fieldName]: heading,
      ...Object.fromEntries(options.map(o => [o.key, { label: o.label, value: o.value }])),
    },
    listingId ? `listing-page-${listingId}` : 'listing-page',
    lastFetch,
    options.length
  );

  const translatedOptions = options.map(o => ({
    ...o,
    label: translation[o.key]?.label || o.label,
    value: translation[o.key]?.value || o.value,
  }));

  return (
    <section className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {translation[fieldName] || heading}
      </Heading>
      <PropertyGroup
        id="ListingPage.amenities"
        options={translatedOptions}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        showUnselectedOptions={showUnselectedOptions}
      />
    </section>
  );
};

export default SectionMultiEnumMaybe;
